import { observer } from 'mobx-react';

// Hooks
import useQuery from 'hooks/use-query';
import { useStores } from 'hooks/use-stores';

// Models
import CartItem from 'models/CartItem';
import SharedCartItem from 'models/SharedCartItem';

// Components
import CartItemEditModal from './CartItemEditModal';
import CartItemModalContainer from './CartItemModalContainer';

const CartItemEditModalContainer = () => (
  <CartItemModalContainer getCartItemFromQueryParams={getCartItemFromQueryParams}>
    <CartItemEditModal />
  </CartItemModalContainer>
);

const getCartItemFromQueryParams = () => {
  const { rootStore, menuDataStore, checkoutStore } = useStores();
  const { selectedMenu } = menuDataStore;
  const { selectedCart } = checkoutStore;
  const query = useQuery();
  const itemId = query.get('item');
  const menuId = query.get('menu');

  if (!itemId || !menuId || !selectedMenu || !selectedCart) {
    return undefined;
  }

  if (selectedCart.isSharedCart) {
    const { sharedCartReference } = selectedCart;
    const matchingItem = sharedCartReference?.shared_cart_items?.find(({ id }) => id === itemId);

    return matchingItem && sharedCartReference
      ? new SharedCartItem(rootStore, sharedCartReference, { ...matchingItem.toJSON(), ready_for_checkout: false })
      : undefined;
  }

  // Here we need to clone the existing item, so we can discard edits.
  const matchingItem = selectedCart?.items.find(({ id }) => id === itemId);

  return matchingItem ? new CartItem(menuDataStore, matchingItem.toJSON()) : undefined;
};

export default observer(CartItemEditModalContainer);
